import { render, staticRenderFns } from "./Quotationlist.vue?vue&type=template&id=0b2b817a"
import script from "./Quotationlist.vue?vue&type=script&lang=js"
export * from "./Quotationlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports